import { Injectable } from "@angular/core";

import { Adapter } from "../interfaces/adapter.interface";
import { Source } from "../interfaces/gridsource.interface";
import { _GlobalConstants } from "../services/globalConstants.service";
import { TranslateService } from "@ngx-translate/core";

declare var $: any, dump: any, showSuccessMessage: any, showErrorMessage: any;

@Injectable()
export class _GridService {
  public readonly NOT_APPLICABLE_TEXT = "- N/A -";

  private entityTypeAdapter: Adapter;
  private accountAdapterAll: Adapter;
  private accountAdapter: Adapter;
  private accountGroupAdapter: Adapter;
  private currencyPairAdapterAll: Adapter;
  private currencyPairAdapter: Adapter;
  private currencyAdapters: any;
  private liquidityAdapter: Adapter;
  private conditionCriteriaAdapter: Adapter;
  private tradingProviderAdapter: Adapter;

  private subscription: any;
  private globalConstants: any;

  constructor(
    private constants: _GlobalConstants,
    private translate: TranslateService
  ) {
    this.subscription = this.constants.getGlobalConstants().subscribe((res) => {
      this.globalConstants = res;
    });
  }

  RenderStatusBar(statusbar: any, source: Source) {
    //Used to control whether an update is to a new or existing row.
    var newRowId = -1;
    // todo: use css
    var container = $(
      "<div style='overflow: hidden; position: relative; margin: 5px;'></div>"
    );
    var addButton = $(
      "<div style='float: left; margin-left: 10px;'><i class='glyphicon glyphicon-plus'></i><span style='margin-left: 2px; position: relative; top: 0px;'>Add</span></div>"
    );
    var deleteButton = $(
      "<div style='float: left; margin-left: 10px;'><i class='glyphicon glyphicon-remove'></i><span style='margin-left: 2px; position: relative; top: 0px;'>Delete</span></div>"
    );
    var reloadButton = $(
      "<div style='float: left; margin-left: 10px;'><i class='glyphicon glyphicon-refresh'></i><span style='margin-left: 2px; position: relative; top: 0px;'>Reload</span></div>"
    );
    var statusLabel = $(
      "<div id='statusLabel' style='float: left; margin-left: 10px;margin-top: 5px;' class='result-status'></div>"
    );
    var rowsCountLabel = $(
      "<div style='float: right; margin-top: 5px; margin-right: 10px'><span id='rowCountLabel'></span></div>"
    );

    container.append(addButton);
    container.append(deleteButton);
    container.append(reloadButton);
    container.append(statusLabel);
    container.append(rowsCountLabel);
    statusbar.append(container);

    addButton.jqxButton({ width: 60, height: 17 });
    deleteButton.jqxButton({ width: 60, height: 17, disabled: true });
    reloadButton.jqxButton({ width: 60, height: 17 });

    // create new row.
    addButton.click((event) => {
      var grid = source.getGrid();
      // rowid will be negative, so it can be identified as a new row
      // add new row to bottom
      dump("adding new row with id: " + newRowId);
      grid.addrow(newRowId, { rowId: newRowId, enabled: "true" });
      var lastRow = grid.getrows().length - 1;
      grid.beginrowedit(lastRow);
      newRowId--; // ensure next new row has unique id
    });

    // delete row.
    deleteButton.click((event) => {
      var grid = source.getGrid();
      var selectedrowindexes = grid.getselectedrowindexes();
      var rowscount = grid.getdatainformation().rowscount;
      var rows = [];
      for (var i = 0; i < selectedrowindexes.length; i++) {
        if (
          selectedrowindexes[i] >= 0 &&
          selectedrowindexes[i] < parseFloat(rowscount)
        ) {
          rows.push(grid.getrowdata(selectedrowindexes[i].valueOf()));
        }
      }
      grid.clearselection();
      // delete rows
      for (i = 0; i < rows.length; i++) {
        grid.deleterow(rows[i]);
      }
      setDeleteButtonEnabled();
    });

    // reload grid data.
    reloadButton.click(function (event) {
      source.refresh();
    });

    var setDeleteButtonEnabled = () => {
      var grid = source.getGrid();
      var selectedrowindexes = grid.getselectedrowindexes();
      if (selectedrowindexes.length > 0) {
        console.log(
          "setDeleteButtonEnabled: (enable) " + selectedrowindexes.length
        );
        deleteButton.jqxButton({ disabled: false });
      } else {
        console.log(
          "setDeleteButtonEnabled: (disable) " + selectedrowindexes.length
        );
        deleteButton.jqxButton({ disabled: true });
      }
    };

    var setupDeleteListeners = () => {
      var grid = source.getGrid();
      if (!grid) {
        setTimeout(() => {
          setupDeleteListeners();
        }, 100);
      } else {
        grid.onRowselect.subscribe(() => {
          setDeleteButtonEnabled();
        });
        grid.onRowunselect.subscribe(() => {
          setDeleteButtonEnabled();
        });
      }
    };
    setupDeleteListeners();
  }

  GetEntityTypeDataAdapter(): Adapter {
    if (this.entityTypeAdapter == null) {
      var data = [
        {
          value: "all",
          display: "All Accounts",
        },
      ];
      for (
        var i = 0;
        i < this.globalConstants.common.staticValues.entityType.length;
        i++
      ) {
        var entityType = this.globalConstants.common.staticValues.entityType[i];
        if (entityType == "ACCOUNT" || entityType == "ACCOUNT_GROUP") {
          data.push({
            value: entityType,
            display: this.translate.instant(
              "backend.common.staticValues.entityType." + entityType
            ),
          });
        }
      }
      var entityTypeSource = {
        dataType: "json",
        datafields: [
          { name: "value", type: "string" },
          { name: "display", type: "string" },
        ],
        id: "value",
        localdata: data,
        async: false, // required so the value is bound properly
      };
      this.entityTypeAdapter = new $.jqx.dataAdapter(entityTypeSource, {
        autoBind: true,
      });
    }
    return this.entityTypeAdapter;
  }

  GetAccountDataAdapter(includeAllOption): Adapter {
    if (includeAllOption) {
      if (this.accountAdapterAll == null) {
        var accountsSource = {
          dataType: "json",
          datafields: [
            { name: "accountId", type: "string" },
            { name: "displayName", type: "string" },
          ],
          id: "accountId",
          url: "/ajax/accounts",
          type: "GET",
          async: false, // required so the value is bound properly
        };
        this.accountAdapterAll = new $.jqx.dataAdapter(accountsSource, {
          autoBind: true,
          beforeLoadComplete: (records) => {
            var data = [
              {
                display: "All Accounts",
                entityId: 0,
              },
            ];
            for (var i = 0; i < records.length; i++) {
              data.push({
                display: records[i].displayName,
                entityId: records[i].accountId,
              });
            }
            return data;
          },
        });
      }
      return this.accountAdapterAll;
    }
    if (this.accountAdapter == null) {
      var accountsSource = {
        dataType: "json",
        datafields: [
          { name: "accountId", type: "string" },
          { name: "displayName", type: "string" },
        ],
        id: "accountId",
        url: "/ajax/accounts",
        type: "GET",
        async: false, // required so the value is bound properly
      };
      var map = {};
      var setMap = (map) => {
        if (this.accountAdapter && !this.accountAdapter.map) {
          this.accountAdapter.map = map;
        }
      };
      this.accountAdapter = new $.jqx.dataAdapter(accountsSource, {
        autoBind: true,
        beforeLoadComplete: (records) => {
          var data = [];
          for (var i = 0; i < records.length; i++) {
            data.push({
              display: records[i].displayName,
              entityId: records[i].accountId,
            });
          }
          return data;
        },
        downloadComplete: (data, textStatus, jqXHR) => {
          for (var i = 0; i < data.length; i++) {
            map[data[i].accountId] = data[i].displayName;
          }
          setMap(map);
        },
      });
      setMap(map);
    }
    return this.accountAdapter;
  }

  GetAccountGroupDataAdapter(): Adapter {
    if (this.accountGroupAdapter == null) {
      var accountGroupsSource = {
        dataType: "json",
        datafields: [
          { name: "accountGroupId", type: "string" },
          { name: "displayName", type: "string" },
        ],
        id: "accountGroupId",
        url: "/ajax/account-groups",
        type: "GET",
        async: false, // required so the value is bound properly
      };
      var map = {};
      var setMap = (map) => {
        if (this.accountGroupAdapter && !this.accountGroupAdapter.map) {
          this.accountGroupAdapter.map = map;
        }
      };
      this.accountGroupAdapter = new $.jqx.dataAdapter(accountGroupsSource, {
        autoBind: true,
        beforeLoadComplete: (records) => {
          var data = [];
          for (var i = 0; i < records.length; i++) {
            data.push({
              display: records[i].displayName,
              entityId: records[i].accountGroupId,
            });
          }
          return data;
        },
        downloadComplete: (data, textStatus, jqXHR) => {
          for (var i = 0; i < data.length; i++) {
            map[data[i].accountGroupId] = data[i].displayName;
          }
          setMap(map);
        },
      });
      setMap(map);
    }
    return this.accountGroupAdapter;
  }

  GetCurrencyPairDataAdapter(includeAllOption): Adapter {
    if (includeAllOption) {
      if (this.currencyPairAdapterAll == null) {
        var currencySource = {
          datatype: "json",
          datafields: [{ name: "currencyPair", type: "string" }],
          id: "currencyPair",
          url: "/ajax/currency-pairs",
          type: "GET",
          async: false, // required so the value is bound properly
        };
        this.currencyPairAdapterAll = new $.jqx.dataAdapter(currencySource, {
          autoBind: true,
          beforeLoadComplete: (records) => {
            var data = [
              {
                currencyPair: "All",
              },
            ];
            for (var i = 0; i < records.length; i++) {
              data.push(records[i]);
            }
            return data;
          },
        });
      }
      return this.currencyPairAdapterAll;
    }
    if (this.currencyPairAdapter == null) {
      var currencySource = {
        datatype: "json",
        datafields: [{ name: "currencyPair", type: "string" }],
        id: "currencyPair",
        url: "/ajax/currency-pairs",
        type: "GET",
        async: false, // required so the value is bound properly
      };
      this.currencyPairAdapter = new $.jqx.dataAdapter(currencySource, {
        autoBind: true,
      });
    }
    return this.currencyPairAdapter;
  }

  GetCurrencyDataAdapter(includeBlankOption, includeAllOption): Adapter {
    if (this.currencyAdapters == null) {
      this.currencyAdapters = {};
    }
    var key = "ccy";
    if (includeBlankOption) {
      key = key + "-blank";
    }
    if (includeAllOption) {
      key = key + "-any";
    }
    if (!this.currencyAdapters[key]) {
      var currencySource = {
        datatype: "json",
        datafields: [{ name: "currency", type: "string" }],
        id: "key",
        url: "/ajax/currencies",
        type: "GET",
        async: false, // required so the value is bound properly
      };
      this.currencyAdapters[key] = new $.jqx.dataAdapter(currencySource, {
        autoBind: true,
        beforeLoadComplete: (records) => {
          if (includeBlankOption || includeAllOption) {
            var data = [];
            if (includeBlankOption) data.push({ currency: "" });
            if (includeAllOption) data.push({ currency: "(All)" });
            for (var i = 0; i < records.length; i++) {
              data.push(records[i]);
            }
            return data;
          }
          return records;
        },
      });
    }
    if (this.currencyAdapters[key]) {
      return this.currencyAdapters[key];
    }
  }

  GetLiquidityProviderDataAdapter(): Adapter {
    if (this.liquidityAdapter == null) {
      var liquiditySource = {
        datatype: "json",
        datafields: [
          { name: "liquidityProviderId", type: "int" },
          { name: "code", type: "string" },
        ],
        id: "key",
        url: "/ajax/liquidity-providers",
        type: "GET",
        async: false, // required so the value is bound properly
      };
      this.liquidityAdapter = new $.jqx.dataAdapter(liquiditySource, {
        autoBind: true,
      });
    }
    return this.liquidityAdapter;
  }

  GetConditionCriteriaDataAdapter(): Adapter {
    if (this.conditionCriteriaAdapter == null) {
      var data = this.constants.getTranslatedValues(
        "resources.ruleCondition.staticValues.criteria"
      );
      var criteriaSource = {
        datatype: "json",
        datafields: [
          { name: "value", type: "string" },
          { name: "display", type: "string" },
        ],
        id: "value",
        localdata: data,
        async: false, // required so the value is bound properly
      };
      this.conditionCriteriaAdapter = new $.jqx.dataAdapter(criteriaSource, {
        autoBind: true,
      });
    }
    return this.conditionCriteriaAdapter;
  }

  ConfigureEntityEditor(entityDropDown, entityType, isAfterEntityTypeChange) {
    // set entity dropdown, based on entityType/source
    switch (entityType) {
      case "ACCOUNT":
        entityDropDown.jqxDropDownList({
          disabled: false,
          source: this.GetAccountDataAdapter(false),
          displayMember: "display",
          valueMember: "entityId",
        });
        if (isAfterEntityTypeChange) {
          entityDropDown.jqxDropDownList("clearSelection");
        }
        break;

      case "ACCOUNT_GROUP":
        entityDropDown.jqxDropDownList({
          disabled: false,
          source: this.GetAccountGroupDataAdapter(),
          displayMember: "display",
          valueMember: "entityId",
        });
        if (isAfterEntityTypeChange) {
          entityDropDown.jqxDropDownList("clearSelection");
        }
        break;

      default:
        // All Accounts
        entityDropDown.jqxDropDownList({
          source: null,
          disabled: true,
        });
        entityDropDown.jqxDropDownList("clearSelection");
        entityDropDown.jqxDropDownList("setContent", this.NOT_APPLICABLE_TEXT);
        break;
    }
  }

  SetInitialEntityDisplay(entityType, entityId) {
    var entityName;
    switch (entityType) {
      case "ACCOUNT":
        entityName =
          typeof this.GetAccountDataAdapter(false).map[entityId] === "undefined"
            ? ""
            : this.GetAccountDataAdapter(false).map[entityId];
        break;
      case "ACCOUNT_GROUP":
        entityName =
          typeof this.GetAccountGroupDataAdapter().map[entityId] === "undefined"
            ? ""
            : this.GetAccountGroupDataAdapter().map[entityId];
        break;
      default:
        // All Accounts
        entityName = this.NOT_APPLICABLE_TEXT;
        break;
    }
    return (
      '<div class="jqx-grid-cell-left-align" style="margin-top: 6px;">' +
      entityName +
      "</div>"
    );
  }

  GetTradingProviderDataAdapter(organizationId): Adapter {
    var source = {
      datatype: "json",
      datafields: [{ name: "tradingName", type: "string" }],
      id: "key",
      url: `/ajax/trading-accounts/${organizationId}`,
      type: "GET",
      async: false, // required so the value is bound properly
    };
    this.tradingProviderAdapter = new $.jqx.dataAdapter(source, {
      autoBind: true,
    });

    if (this.tradingProviderAdapter) {
      return this.tradingProviderAdapter;
    }
  }

  SuccessMsg(msgContainer, msg) {
    showSuccessMessage($("#" + msgContainer), msg);
  }

  ErrorMsg(msgContainer, msg) {
    showErrorMessage($("#" + msgContainer), msg);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/ng1-services/grid.service.ts